import verified from "./address/verified";

export default {
    verified
}